import { createTypes } from 'redux-action-types'

export const types = createTypes('fridge/alert/',
  'PUSH'
)

export const alert = (settings) => {
  return {type: types.PUSH, settings}
}



// WEBPACK FOOTER //
// ./app/actions/alerts.js